import React, { useState } from "react";
import certi1 from "../../assets/page icons/carbon neutralized 10.png";
import certi2 from "../../assets/page icons/eco 2.png";
import certi3 from "../../assets/page icons/global 1.png";
import certi4 from "../../assets/page icons/global organic 1.png";
import certi5 from "../../assets/page icons/oekotex 2.png";
import certi6 from "../../assets/page icons/organiceu 1.png";
import certi7 from "../../assets/page icons/member 1.png";
import certi8 from "../../assets/page icons/usda organic 1.png";
import layer_1 from "../../assets/images/layers/layer_1.png";
import layer_2 from "../../assets/images/layers/layer_2.png";
import layer_3 from "../../assets/images/layers/layer_3.png";
import layer_4 from "../../assets/images/layers/layer_4.png";
import layer_5 from "../../assets/images/layers/layer_5.png";
import layer_6 from "../../assets/images/layers/layer_6.png";
import shadow_layer from "../../assets/images/layers/shadow.png";
export default function Layers() {
  const [active, setActive] = useState(1);
  const layers = [
    {
      id: 1,
      title: "BOYTEKS ICE SLEEP FABRIC",
      layer: layer_1,
      subtitle: "Surface Comfort Layer",
      para: `Finished with Boyteks Ice Sleep fabric and knitted quilt
detailing, creating a cool, breathable surface that feels
smooth and comfortable from the moment you lie down`,
    },
    {
      id: 2,
      title: "14D LEXUS FOAM",
      layer: layer_2,
      subtitle: "Quilted Comfort Layer (24mm)",
      para: `Designed with 24mm of foam quilting that adds a gentle
cushioning layer, enhancing surface comfort while maintaining
overall support
`,
    },
    {
      id: 3,
      title: "LATEXT 65D",
      layer: layer_3,
      subtitle: "Natural Latex Layer (25mm)",
      para: `Made with 25mm of natural latex that provides responsive
support, adapts quickly to movement, and helps relieve
pressure without excessive sinking`,
    },
    {
      id: 4,
      title: "40D LEXUS PROFILE",
      layer: layer_4,
      subtitle: "Breathable confort layer (50mm)",
      para: `Crafted with contoured profile foam that improves airflow,
helping maintain breathability and reduce heat buildup across
the mattress`,
    },
    {
      id: 5,
      title: "rbf 100d",
      layer: layer_5,
      subtitle: "ortho support core (100mm)",
      para: `Constructed with high-density rebonded foam that delivers
firm, stable support and helps maintain proper
spinal alignment over time`,
    },
    {
      id: 6,
      title: "14d lexus foam",
      layer: layer_6,
      subtitle: "bottom quilting with stability layer (12mm)",
      para: `Added as a base cushioning layer to support structural
balance, paired with anti-skid fabric to help keep the
mattress securely in place during use`,
    },
  ];
  const onHover = (id) => {
    setActive(id);
  };

  return (
    <div className="bg-[#ecf2fe] py-4 md:py-12">
      <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto md:p-0  md:mt-8">
        {/* Heading Section */}
        <h2
          className="font-lexend md:text-[40px] text-xl sm:text-base xl:text-[38px] px-5 md:p-0 3xl:text-[45px] md:font-extralight font-light text-[#333335] leading-[1.2] pb-5"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Every layer crafted with care, <br /> so every night brings better
          sleep.
        </h2>

        <p
          className="md:py-2 py-1 w-full lg:w-[90%] font-lexend font-light text-[#6d6d6f] px-5 md:p-0 sm:text-xs text-[16px] 3xl:text-running leading-[1.8rem]"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          The Ortho Latex Mattress isn't just built — it's thoughtfully designed
          from the inside out. Each layer has a purpose, working together to
          deliver balanced support, pure comfort, and healthier rest for years
          to come.
        </p>
        {/* Now we a separate layers to reduce compexity // For Mobile and Tabs Screen */}
        <div className="lg:hidden flex  mt-14 relative w-full px-2 isolate  justify-center items-center flex-col pb-5">
          {layers.map((item, index) => {
            const isActive = active === item.id;
            const isLeft = index % 2 === 0;
            return (
              <div
                key={index + item.id}
                className="flex justify-center items-end w-full  relative"
              >
                <img src={item.layer} alt={item.title} />
                <div
                  onClick={() => onHover(item.id)}
                  className={`absolute px-2 w-1/2 flex cursor-pointer ${isLeft ? "justify-start" : "justify-end"} items-center`}
                  style={{
                    zIndex: isActive ? 100 : layers.length - index,
                  }}
                >
                  {/* CENTER NUMBER */}
                  <div className="relative lg:w-11 lg:h-11 w-10 h-10 flex justify-center items-center">
                    {/* Pulse Effect */}
                    <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-75 animate-ping "></span>
                    {/* Outer Circle */}
                    <div className="relative lg:w-12 lg:h-12 xxs:w-8 xxs:h-8 w-10 h-10 rounded-full flex justify-center items-center b z-10">
                      {/* Inner Circle */}
                      <span
                        className={`lg:w-10 lg:h-10  w-8 h-8 xxs:w-6 xxs:h-6 xxs:text-[12px] rounded-full font-bold flex justify-center items-center ${
                          active === item.id
                            ? "text-[#f4e391] bg-[#24522f]"
                            : "bg-[#f4e391] text-[#24522f]"
                        }`}
                      >
                        {index + 1}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="px-2 pt-5">
            {layers
              .filter((u) => u.id === active)
              .map((item, index) => (
                <div
                  key={item.para}
                  className={` w-full p-4 rounded-xl bg-[#194083]  transition-all duration-500 ease-out 
      sm:left-20 left-16 xs:left-[65px] ml-20" 
               `}
                >
                  <h4 className="text-[#f4e391] sm:text-base xxs:text-sm text-lg uppercase font-lexend font-semibold leading-tight">
                    {item.title}
                  </h4>
                  <h5 className="text-white sm:text-sm xxs:text-xs  capitalize font-medium mb-1">
                    {item.subtitle}
                  </h5>
                  <p className="text-[#88c1ea] sm:text-sm xxs:text-xs text-base">
                    {item.para}
                  </p>
                </div>
              ))}
          </div>
        </div>

        <div className="lg:flex hidden mt-14 relative w-full  isolate  justify-center items-center flex-col px-2 pb-40">
          {layers.map((item, index) => {
            const isLeft = index % 2 === 0;
            const isActive = active === item.id;
            return (
              <div
                key={index + item.id}
                className="flex justify-center items-center w-full  relative"
              >
                <img src={item.layer} alt={item.ti} />
                <div className="absolute  flex justify-center items-end z-10 w-full h-full">
                  <div
                    onMouseEnter={() => onHover(item.id)}
                    className="absolute w-full  flex cursor-pointer justify-center"
                    style={{
                      zIndex: isActive ? 100 : layers.length - index,
                    }}
                  >
                    <div className="relative w-11 h-11 flex justify-center items-center">
                      <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-75 animate-ping"></span>
                      <div className="relative w-10 h-10 rounded-full flex justify-center items-cente z-10">
                        <span
                          className={`w-10 h-10 rounded-full flex justify-center font-semibold items-center ${
                            active === item.id
                              ? "text-[#f4e391] bg-[#24522f]"
                              : "bg-[#f4e391] text-[#24522f]"
                          }`}
                        >
                          {index + 1}
                        </span>
                      </div>
                    </div>
                    <div
                      className={`absolute max-w-[580px] min-w-[420px] ps-6 py-6 pe-10 rounded-xl -top-20 bg-[#194082] transition-all duration-500 ease-out 
        ${isLeft ? "right-1/2 mr-16 xl:mr-20" : "left-1/2 xl:ml-20 ml-16"} 
        ${
          isActive
            ? "opacity-100 translate-y-0 scale-100 visible"
            : "opacity-0 translate-y-2 scale-95 pointer-events-none invisible"
        }`}
                      style={{ top: "-20px" }}
                    >
                      <h4 className="text-[#f4e391] xl:text-xl text-lg uppercase font-lexend font-semibold leading-tight">
                        {item.title}
                      </h4>
                      <h5 className="text-white xl:text-lg text-base capitalize font-lexend  font-normal mb-1">
                        {item.subtitle}
                      </h5>
                      <p className="text-[#88c1ea] xl:text-lg text-sm font-light font-lexend ">
                        {item.para}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <img src={shadow_layer} className="bottom-0 absolute -z-10" alt="" />
        </div>
        <div className="md:bg-[#fff] md:rounded-[50px] px-6  mt-4 md:mt-0 md:p-14 ">
          <div className="grid md:bg-transparent bg-[#fff] rounded-md grid-cols-4 lg:flex p-5 md:p-0 lg:gap-7 items-center justify-between gap-5">
            <div>
              <img src={certi1} alt="certi1" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi2} alt="certi2" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi3} alt="certi3" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi4} alt="certi4" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi5} alt="certi5" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi6} alt="certi6" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi7} alt="certi7" className="w-full h-auto" />
            </div>
            <div>
              <img src={certi8} alt="certi8" className="w-full h-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
